import React from 'react';
import PropTypes from 'prop-types';
import { RegistryTile } from '@zola/component-public-registry';
import RegistryCollectionHeader from './RegistryCollectionHeader';
import RegistryCollectionItemTile from './RegistryCollectionItemTile';
import featureFlags from '../../util/featureFlags';

const GIFT_CARD_TYPE = 'GIFT_CARD';
const RegistryGrid = ({ collection, collectionItems, onAddToCart, onShowProduct, enableCustomCollections }) => {
  if (collectionItems.length === 0) return null;

  return (
    <div className="row">
      {collection && <RegistryCollectionHeader collection={collection} enableCustomCollections={enableCustomCollections} count={collectionItems.length} />}
      {collectionItems.map((collectionItem) => {
        const isDefaultGiftCard = collectionItem.type === GIFT_CARD_TYPE;
        if (featureFlags.get('modularizedRegistryTile')) {
          return (
            <RegistryTile
              onClick={() => { onShowProduct(collectionItem, isDefaultGiftCard); }}
              collectionItemDetail={collectionItem}
              onAddToCart={onAddToCart}
              key={collectionItem.object_id || collectionItem.id}
              registryKey="test"
              isDefaultGiftCard={isDefaultGiftCard}
              id={collectionItem.object_id || collectionItem.id}
            />
          );
        }
        return (
          <div className="col-lg-3 col-sm-4 col-xs-6">
            <RegistryCollectionItemTile
              collectionItem={collectionItem}
              onAddToCart={onAddToCart}
              onShowProduct={onShowProduct}
              isDefaultGiftCard={isDefaultGiftCard}
              key={collectionItem.object_id || collectionItem.id}
              id={collectionItem.object_id || collectionItem.id}
            />
          </div>
        );
      })}
    </div>
  );
};

RegistryGrid.propTypes = {
  collection: PropTypes.shape({}),
  collectionItems: PropTypes.arrayOf(PropTypes.shape({})),
  onAddToCart: PropTypes.func.isRequired,
  onShowProduct: PropTypes.func.isRequired,
  enableCustomCollections: PropTypes.bool
};

export default RegistryGrid;



// WEBPACK FOOTER //
// ./src/components/registry/RegistryGrid.jsx